// Credit: https://www.bearer.com/blog/how-to-build-modals-with-hotwire-turbo-frames-stimulusjs

import { Controller } from "@hotwired/stimulus"
import { useHotkeys } from "stimulus-use/hotkeys"

// Connects to data-controller="modal"
export default class extends Controller {

  static values = {
    autofocus: { type: Boolean, default: true },
    closeOnEscape: { type: Boolean, default: false },
    closeOnBackgroundClick: { type: Boolean, default: true },
    closeOnFormComplete: { type: Boolean, default: true }
  }

  connect() {
    // this.clearFlashMessages()
    this.autofocusValue && this.focusFirstInput()
    useHotkeys(this, { "escape": [this.handleEscape]})
  }
  
  // This is also clearing the flash messages so they are not displayed at all
  // clearFlashMessages() {
  //   document.querySelector("#flash-container").innerHTML = ""
  // }
  
  openModal(e) {
    const link = e.currentTarget
    const modal = this.element.querySelector(".modal-bg") 
    modal.classList.remove("hidden")
  }
  
  get errorInput() {
    return this.element.querySelector(".form-item.error input:not([type=hidden]):not([disabled]), .form-item.error textarea:not([disabled]), .form-item.error select:not([disabled])")
  }

  get firstInput() {
    const explicitInput = this.element.querySelector("input[autofocus]:not([type=hidden]), textarea[autofocus], select[autofocus]")
    const implicitInput = this.element.querySelector("input:not([type=hidden]):not([disabled]), textarea:not([disabled]), select:not([disabled])")
    return explicitInput || implicitInput
  }
  
  focusFirstInput() {
    const input = this.errorInput || this.firstInput
    if (!input) return
    setTimeout(() => {
      (input.tomselect || input).focus()
    }, 50);
  }

  hide() {

    // Trigger a custom event
    this.dispatch("close", { detail: { modal: this.element } })
    
    // Remove the src attribute from the parent element
    this.element.parentElement.removeAttribute("src")
    // Close all parent element children with data-close-group attribute
    this.element.parentElement.querySelectorAll("[data-close-group]").forEach(modal => modal.remove())
    // Remove this element (if it still exists)
    this.element?.remove()

    // Possible alternative if we need to reinstate the turbo:submit-end event listener below
    // 1) Identify the top-most modal
    // 2) If it has a data-close-group attribute, close all modals inside #global-modal
    // 3) If it doesn't have a data-close-group attribute, just close itself
    // 4) We will target this manually for now using document.querySelector - we need the last one
  }

  handleBackgroundClick(event) {
    if (this.closeOnBackgroundClickValue && event && event.target === this.element) {
      this.hide()
    }
  }

  handleEscape() {
    if (this.closeOnEscapeValue) {
      this.hide()
    }
  }

  // turbo:submit-end seems to call before the modal is in the DOM
  // This was probably included to remove modals when a form has successfully submitted and redirected and on back button modal was still there
  // If we need to reinstate this, we can change the hide() method above to purely remove the "top-most" modal inside #global-modal it finds etc
  handleSubmitEnd(event) {
    if (event.target.method !== "post") return
    const modal = event.target.closest("[data-controller='modal']")
    if (modal && modal.getAttribute("data-modal-close-on-form-complete-value") === "true") {
      this.hide()
    }
  
  }
  
}
